export default __webpack_public_path__ + "static/media/cactusmexicanfood.9f050da9.jpeg";